import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ShellAction {
  label:   string;
  variant: 'primary' | 'outline';
  handler: () => void;
}

export interface ShellBreadcrumb {
  backHandler: () => void;
  badgeText:   string | null;
  /**
   * The plan's confirmed platforms as `sp-platform-icon` ids ('youtube',
   * 'tiktok', …), in plan order; empty or absent before a platform is
   * confirmed. QA E2E FE-4: the header used to show a hard-coded YouTube icon
   * on every plan, TikTok-only plans and `/plan/new` included.
   */
  platformIcons?: string[];
}

/**
 * Communication bus between routed pages and the app-shell header.
 *
 * Pages push their context on init and clear it on destroy:
 *   - Home  → registers CTA actions (View all plans / Generate New Plan)
 *   - Plan  → registers breadcrumb back-handler + optional plan-ID badge
 */
@Injectable({ providedIn: 'root' })
export class ShellHeaderService {
  private readonly actionsSource    = new BehaviorSubject<ShellAction[]>([]);
  private readonly breadcrumbSource = new BehaviorSubject<ShellBreadcrumb | null>(null);

  readonly actions$    = this.actionsSource.asObservable();
  readonly breadcrumb$ = this.breadcrumbSource.asObservable();

  setActions(actions: ShellAction[]): void   { this.actionsSource.next(actions); }
  clearActions(): void                        { this.actionsSource.next([]); }

  setBreadcrumb(bc: ShellBreadcrumb): void    { this.breadcrumbSource.next(bc); }
  clearBreadcrumb(): void                     { this.breadcrumbSource.next(null); }
}
